import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'scheduler/config/meetingTypes';

export function useMeetingTypesQuery({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IMeetingTypeSummary[]>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'scheduler/config/meetingTypes' }),
				'GET'
			),
		meta: {
			errorLogging: { category: 'Scheduler', action: 'MeetingTypesQuery-Error' },
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext?.account?.id ?? null],
		refetchOnWindowFocus: false,
		// The email editor waits for this optional list before it mounts, so a failure must not hold it through retries.
		retry: false,
	});
}

export const invalidateMeetingTypesQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
